import * as yup from 'yup';
import { StaticDataModel } from '../../../Component/Model/Dto/StaticData';

export const OrgnaisationLinkScorecardValidationSchema = yup.object().shape({
    scorecard: yup.object().shape({
      Id: yup.string(),
      Name: yup.string(),
    })
    .nullable().required('Please select a scorecard to link'),
    
  });

